import api from "@/api";
const state = () => ({
	items: null,
	departmentId: null,
});

const actions = {
	async fetch({ commit, dispatch }, departmentId) {
		commit('setDepartmentId', departmentId)
		const data = await api({ url: `/123/categories/${departmentId}/products` });
		data.err
			? dispatch("error/showError", data.err, { root: true })
			: commit("UPDATE", data.info);
	},
};

const getters = {
	byCategory({ items, departmentId }, getters, rootState) {
		if (items && rootState.departments.data.length) {
			const ordered = {}
			const unordered = items.reduce((acc, i) => {
				acc[i.category_name] = acc[i.category_name] || [];
				acc[i.category_name].push(i);
				return acc;
			}, {})

			const order = rootState.departments.data.find(d => d.category_id == departmentId)?.sub_categories;
			order.sort((a, b) => b.popularity - a.popularity);
			order.forEach(category => {
				ordered[category.category_name] = unordered[category.category_name]
			})

			return ordered;
		}
	},
};

const mutations = {
	UPDATE(state, payload) {
		state.items = payload;
	},
	setDepartmentId(state, payload) {
		state.departmentId = payload;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
};
